import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';

@Component({
  selector: 'hmax-simple-tag',
  standalone: true,
  templateUrl: './simple-tag.component.html',
  styleUrls: ['./simple-tag.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatTooltipModule],
})
export class SimpleTagComponent {
  @Input() type: 'success' | 'info' | 'warn' | 'alert' = 'success';
  @Input() text!: string;
  @Input() tooltip!: string;
  @Input() tooltipPosition: TooltipPosition = 'above';
}
